<template>
    <el-dialog
        width="500px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="reasonDialogVisible"
        :before-close="handleClose"
    >
    <span slot="title"><span>提示: </span><span style="color: red;">虚假选择，红线处理！</span></span>
        <el-form
            :model="form"
            :rules="rules"
            label-width="100px"
            class="from"
            ref="ruleForm"
        >
            <div class="type-tip">
                <span class="icon-tip"><i class="el-icon-warning"></i></span>
                    <span>在直控线路使用非直控运力，请选择原因：</span>
                </div>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="原因" prop="firstReasonType">
                        <selects
                            :optionNum="'NEW_PRIMARY_DIRECT_CONTROL_LINE'"
                            :mValue="form.firstReasonType"
                            @getSelectValue="getSelectValue"
                            placeholder="请选择原因"
                            :prop="'firstReasonType'"
                        ></selects>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSure">保 存</el-button>
        </span>
    </el-dialog>
</template>
<script>
import selects from '@/components/lots/otpSelect';

export default {
    components: { selects },
    props: {
        reasonDialogVisible: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            form: {
                firstReasonType: '',
                firstReasonValue: '',
                reasonDialogVisible: true,
                directControlTransportCapacityFlag: false

            },
            rules: {
                firstReasonType: [
                    { required: true, message: '请选择原因', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        getSelectValue (data, label) {
            this.form = {
                ...this.form,
                ...data
            };
            this.form.firstReasonValue = label;
        },
        handleClose () {
            this.form = {};
            this.$emit('update:reasonDialogVisible', false);
        },
        handleSure () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$emit('handleSure', this.form);
                }
            });
        }
    }
};
</script>
<style lang="less" scoped >
/deep/ .el-select {
    width: 100%;
}
.type-tip {
    font-size: 14px;
    margin-bottom: 8px;
    margin-left: 26px
}
.icon-tip {
    color: coral;
    font-size: 16px;
    margin-right: 4px;
}
</style>
